import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import Box from '@tds/core-box';

import { Link as NavLink } from 'react-router-dom';
import { colorTelusPurple } from '@tds/core-colours';

export const TableWrapper = styled.table`
  width: 100%;
  @media screen and (max-width: 992px) {
    overflow-y: scroll;
    display: block;
  }
`;

export const Th = styled.td`
  color: #595859;
  background-color: #e2e2e2;
  padding: 0.4rem;
  text-align: center;
  cursor: pointer;
  font-weight: 500;
`;

export const Link = styled(NavLink)`
  color: #2a2c2e;
  text-decoration: none;
  font-weight: 400;
  cursor: pointer;
`;

export const Td = styled.td`
  padding: 0.5rem;
  text-align: center;
  ${props =>
    props.actionStyles &&
    css`
      display: ${props.actionsDisplay};
      justify-content: center;
    `}
`;

Td.propTypes = {
  actionStyles: PropTypes.bool,
  actionsDisplay: PropTypes.string
};

Td.defaultProps = {
  actionStyles: false,
  actionsDisplay: 'flex'
};

export const Tr = styled.tr`
  background-color: ${props => {
    if (props.isDeleted) {
      return 'rgb(255, 230, 230)';
    }
    if (props.isOdd) {
      return '#f9fafa';
    }
    return '#f9f1ff';
  }};
`;

Tr.propTypes = {
  isOdd: PropTypes.number
};

export const Heading = styled.div`
  margin: 32px 8px;
  color: black;
  font-size: 32px;
  color: ${colorTelusPurple};
`;

export const PaginationContainer = styled.div`
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border: 1px solid #dadada;
  border-radius: 25px;
  box-shadow: 1px 1px 5px 0 #d5d5d5;
  height: 48px;
  margin: 16px 0 28px !important;
  padding: 1rem;
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  min-height: 20px;
  margin-right: 8%;
`;

export const PageButtons = styled.button`
  background-color: ${props =>
    props.item === props.currentPage
      ? 'transparent !important'
      : '#fff !important'};
  width: 48px;
  height: 32px;
  border: ${props =>
    props.item === props.currentPage ? 'none' : '2px solid #fff'};
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-content: center;
  cursor: default;
  font-weight: 500;
  color: ${props => (props.item === props.currentPage ? 'white' : 'black')};

  &: hover {
    border-color: #4b286d;
  }
  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;

export const ActivePage = styled.button`
  background-color: #4b286d !important;
  color: #fff;
  width: 48px;
  height: 32px;
  border: none;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-content: center;
  cursor: default;
  font-weight: 500;

  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;

export const NaviagationButtonText = styled.p`
  font-size: 24px;
  margin-top: -7px;
  text-decoration: none !important;
`;

export const NaviagationButtons = styled.button`
  background-color: #fff;
  width: 48px;
  height: 32px;
  border: 2px solid #fff;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-content: center;
  cursor: default;
  color: #4b286d;
  font-weight: 500;
  align-item: center;
  text-decoration: none !important;

  &: hover {
    background-color: #f7f7f8 !important;
  }
  &:active {
    outline: none;
  }
  &:focus {
    outline: none;
  }
`;

export const Page = styled(Box)`
  text-align: center;
  width: auto;
  height: 25px;
  padding: 2px 6px;
  margin: 2px;
  font-size: 0.85rem;
  font-weight: ${props => (props.item === props.currentPage ? '600' : '400')};
  color: ${props => (props.item === props.currentPage ? '#ffffff' : '#49166d')};
  background-color: ${props =>
    props.item === props.currentPage ? '#a2a2a2' : '#ffffff'};
`;
PageButtons.propTypes = {
  item: PropTypes.number,
  currentPage: PropTypes.number
};
PageButtons.defaultProps = {
  item: 1,
  currentPage: 1
};

Page.propTypes = {
  item: PropTypes.number,
  currentPage: PropTypes.number
};

Page.defaultProps = {
  item: null,
  currentPage: 1
};
